import { useCallback, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { DEVICE_ID_KEY } from '../utils/Constants';

const useDevice = () => {
    const [deviceId, setDeviceId] = useState(() => {
        try {
            const localDeviceId = localStorage.getItem(DEVICE_ID_KEY) ?? null;
            if (localDeviceId) {
                return localDeviceId;
            } else {
                const uuid = uuidv4();
                localStorage.setItem(DEVICE_ID_KEY, uuid);
                return uuid;
            }
        } catch (error) {
            console.log(error);
            localStorage.removeItem(DEVICE_ID_KEY);
            return null;
        }
    });

    const createDeviceId = useCallback(() => {
        try {
            const localDeviceId = localStorage.getItem(DEVICE_ID_KEY) ?? null;
            if (localDeviceId) {
                setDeviceId(localDeviceId);
            } else {
                const uuid = uuidv4();
                localStorage.setItem(DEVICE_ID_KEY, uuid);
                setDeviceId(uuid);
            }
        } catch (error) {
            console.log(error);
            localStorage.removeItem(DEVICE_ID_KEY);
            setDeviceId(null);
        }
    }, []);

    const removeDeviceId = useCallback(() => {
        localStorage.removeItem(DEVICE_ID_KEY);
        setDeviceId(null);
    }, []);

    return {
        deviceId,
        createDeviceId,
        removeDeviceId,
    };
};

export default useDevice;
